export const supportedLanguages = [
  { value: "en", label: "English" },
  { value: "es", label: "Español (Spanish)" },
  { value: "fr", label: "Français (French)" },
  { value: "de", label: "Deutsch (German)" },
  { value: "da", label: "Dansk (Danish)" },
  { value: "hi", label: "हिन्दी (Hindi)" },
  { value: "it", label: "Italiano (Italian)" },
  { value: "ja", label: "日本語 (Japanese)" },
  { value: "ko", label: "한국어 (Korean)" },
  { value: "fi", label: "Suomi (Finnish)" },
  { value: "nl", label: "Nederlands (Dutch)" },
  { value: "pt", label: "Português Europa (European Portuguese)" },
  { value: "ro", label: "Română (Romanian)" },
  { value: "sv", label: "Svenska (Swedish)" },
  { value: "no", label: "Norsk (Norwegian)" },
  { value: "th", label: "ไทย (Thai)" },
  { value: "tr", label: "Türkçe (Turkish)" },
  { value: "ur", label: "اردو (Urdu)" },
  { value: "vn", label: "Tiếng Việt (Vietnamese)" },
  { value: "id", label: "Bahasa Indonesia (Indonesian)" },
  { value: "zh-Hant", label: "繁體中文 (Traditional Chinese)" },
  { value: "lv", label: "Latviešu (Latvian)" },
  { value: "ar", label: "العربية (Arabic)" },
  { value: "bs", label: "Bosanski (Bosnian)" },
  { value: "sl", label: "Slovenski (Slovenian)" },
] as const

export const supportedLanguageCount = supportedLanguages.length
